import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckboxCheckIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 10 10"
            fill="none"
            data-testid="check-icon"
            aria-hidden="true"
            width="100%"
            height="100%"
            {...props}
        >
            <g filter="url(#filter0_d_3291_843)">
                <path
                    d="M8.33334 2.71L3.75001 7.29L1.66667 5.21"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_3291_843"
                    x="-1.08333"
                    y="0"
                    width="12.1667"
                    height="11.1"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0509804 0 0 0 0 0.301961 0 0 0 0 0.796078 0 0 0 1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3291_843"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3291_843"
                        result="shape"
                    />
                </filter>
            </defs>
        </Icon>
    )
}

export default CheckboxCheckIcon
